import translating from './translate.json';
import GlobalContext from '../../contexts';
import { useContext } from 'react';
import { validateForm } from '../../utils';

const fields = (orgClient) => {
  const { organizationsList, typeEnum, sourceList } = useContext(GlobalContext);

  let fieldsArr = [
    {
      name: 'first_name',
      label: translating.firstName,
      pattern: validateForm('first_name', translating.firstName),
      required: true
    },
    {
      name: 'last_name',
      label: translating.lastName,
      required: true,
      pattern: validateForm('last_name', translating.lastName)
    },
    {
      name: 'ssn',
      label: translating.tz,
      required: true,
      pattern: validateForm('ssn', translating.tz)
    },
    {
      name: 'date_of_birth',
      label: translating.dateBirth,
      required: true,
      type: 'date'
    },
    {
      breakLine: true,
      name: 'gender',
      label: translating.gender,
      required: true,
      type: 'radio',
      options: [
        { id: '1', name: 'גבר' },
        { id: '2', name: 'אשה' }
      ]
    },
    {
      name: 'height',
      label: translating.height,
      pattern: /^\d+$/
    },
    {
      name: 'weight',
      label: translating.weight,
      pattern: /^\d+$/
    },
    {
      name: 'city',
      required: true,
      label: translating.city,
      breakLine: true,
      type: 'address'
    },
    {
      name: 'street',
      required: true,
      label: translating.street,
      type: 'address'
    },
    {
      name: 'buildingNumber',
      required: true,
      label: translating.buildingNumber,
      width: '80px',
      type: 'number'
    },
    {
      name: 'apartmentNumber',
      required: true,
      label: translating.apartmentNumber,
      width: '80px',
      type: 'number'
    },
    {
      name: 'mobile',
      required: true,
      label: translating.mobile,
      pattern: validateForm('mobile', translating.mobile),
      breakLine: true
    },
    {
      name: 'phone',
      label: translating.phone,
      pattern: validateForm('phone', translating.phone)
    },
    {
      name: 'email',
      required: true,
      label: translating.email,
      pattern: validateForm('email', translating.email)
    },
    {
      name: 'organizationId',
      label: translating.organization,
      type: 'select',
      // default: organizationsList[0]?.id,
      fromOptions: 'organization',
      required: true,
      options: organizationsList,
      breakLine: true
    },
    {
      name: 'client_publication_source',
      label: translating.source,
      type: 'select',
      required: true,
      default: 'אורגני',
      options: sourceList
    },
    {
      name: 'client_type',
      label: translating.type,
      type: 'select',
      required: true,
      options: typeEnum
    },
    {
      name: 'isActive',
      label: translating.status,
      type: 'switch',
      default: true
    },
    {
      name: 'allow_rceive_emails',
      label: translating.allowEmails,
      type: 'switch',
      default: true
    }
  ];
  if (orgClient) {
    let index = fieldsArr.findIndex((f) => f.name === 'organizationId');
    fieldsArr.splice(index, 1);
    let nextField = fieldsArr[index];
    if (nextField) fieldsArr[index].breakLine = true;
  }
  return fieldsArr;
};

export default fields;
